import Dialog from 'material-ui/Dialog';
import {CancelButton, SaveButton} from './';
import React, {PropTypes} from 'react';

export default function CreateEditModal({show, title, form, onCancel, onSave, loading, saving}) {
  const actions = [
    <CancelButton onClick={onCancel} disabled={loading || saving} />,
    <SaveButton loading={loading} saving={saving} onClick={onSave} />
  ];

  return (
    <Dialog
      title={title || 'Confirm'}
      actions={actions}
      modal
      open={show}>
      {form}
    </Dialog>
  );
}

CreateEditModal.propTypes = {
  form: PropTypes.element.isRequired,
  loading: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/features/shared/components/CreateEditModal.js